import React, { Component } from 'react';
import Dom from 'react-dom';
import PropTypes from 'prop-types';
import { keys, merge, map, equals, find, identity, path, indexOf } from 'ramda';
import { FormattedMessage } from 'react-intl';

import GradeableSection from '../../components/GradeableSection';
import InfoDialog from 'routes/Documents/components/InfoDialog';

// const isMobile = () => !!(window.innerHeight < 600 || window.innerWidth < 600);

/**
 * Checks whether the element is sufficiently aligned in the viewport already.
 * This is used to determine whether there's a need to scroll the element into view at all.
 * We want to check that the element is below the top controls and within about 1/3 of the available viewport
 * @param {DOMNode} el Dom node of the element to check.
 */
const elementInViewport = el => {
  let bb = el.getBoundingClientRect();
  let lowerBound = 80;
  return (
    bb.top >= lowerBound && bb.top <= ((window.innerHeight || document.documentElement.clientHeight) - lowerBound) / 3
  );
};

class GradeableContainer extends Component {
  static propTypes = {
    input: PropTypes.object,
    localeAccessor: PropTypes.func,
    sections: PropTypes.object,
    localeMessage: PropTypes.func,
    editing: PropTypes.bool,
    isInDialog: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    // Open first automatically if new status entry (no previous values)
    this.state = { openSection: !path(['value'], this.props.input) ? keys(this.props.sections)[0] : null };
    this.handleOpen = sect => () => {
      this.setState((s, p) => ({ openSection: sect }));
      if (sect != null) {
        const currentNode = Dom.findDOMNode(this.refs[sect]);
        setTimeout(this.handleAutoScroll, 250);
      }
    };

    this.getLocale = sect => grade => this.props.localeMessage(this.props.localeAccessor(sect, grade));

    this.handleAutoScroll = () => {
      const { input, sections, isInDialog } = this.props;
      const currentSection = this.state.openSection;
      const nextSection = find(s => !(input.value[s] >= 0), keys(sections));

      const scrollOffset = 100; // getAutoScrollOffset(this.state.openSection);

      if (!isInDialog && currentSection) {
        const currentNode = Dom.findDOMNode(this.refs[currentSection]);
        if (!elementInViewport(currentNode))
          window.scrollTo({
            top: currentNode.offsetTop - scrollOffset,
            left: 0,
            behavior: 'smooth',
          });
      }
    };

    this.handleSelect = sect => grade => () => {
      this.props.input.onChange(merge(this.props.input.value, { [sect]: grade }));
      const nextSect = Object.keys(this.props.sections)[indexOf(sect, Object.keys(this.props.sections)) + 1];
      this.handleOpen(null)();
    };

    this.estimateChange = sect => (e, v) => {
      this.props.input.onChange(merge(this.props.input.value, { [sect + 'VASValue']: v }));
    };
  }

  render() {
    const { sections, input, editing } = this.props;
    const { openSection } = this.state;
    const { handleOpen, handleSelect, getLocale, estimateChange } = this;

    let sectionList = JSON.parse(JSON.stringify(sections));

    const hasGrades = !editing
      ? input.value &&
        typeof input.value === 'object' &&
        Object.keys(input.value).some(key => !key.includes('VASValue'))
      : sections && typeof sections === 'object' && Object.keys(sections).some(s => s === 'prEDSS');

    return (
      <div>
        {map(s => (
          <div key={`gradeable_${s}`} ref={s}>
            <GradeableSection
              section={s}
              grades={sections[s]}
              value={path(['value', [s]], input)}
              isOpen={editing && equals(openSection, s)}
              getLocale={getLocale(s)}
              onOpen={!editing ? identity : handleOpen(s)}
              onSelect={!editing ? identity : handleSelect(s)}
              estimateSlider={s !== 'prEDSS'}
              estimateValue={path(['value', [s + 'VASValue']], input)}
              estimateOnChange={!editing ? null : estimateChange(s)}
              hasGrades={s === 'prEDSS'}
              infoComponent={() => (
                <InfoDialog
                  value={<FormattedMessage id={`status.${s}.infoDialogText`} values={{ br: <br /> }} />}
                  buttonComponent={onClickFunction => (
                    <a
                      onClick={onClickFunction}
                      style={{ color: '#048b82', cursor: 'pointer', fontWeight: 600, fontSize: '1.1em' }}
                    >
                      <FormattedMessage id={`status.${s}.dialogButtonText`} />
                    </a>
                  )}
                />
              )}
            />
          </div>
        ))(keys(sectionList))}
      </div>
    );
  }
}

export default GradeableContainer;
